import React, { createContext, useContext, useRef, ReactNode } from 'react'

type FileUploadContextType = {
  callUploadFile: (onFileSelected: (file: File) => void) => void
}

const FileUploadContext = createContext<FileUploadContextType | undefined>(undefined)

export const FileUploadProvider = ({ children }: { children: ReactNode }) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const callbackRef = useRef<(file: File) => void>()

  const callUploadFile = (onFileSelected: (file: File) => void) => {
    callbackRef.current = onFileSelected
    inputRef.current?.click()
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file && callbackRef.current) {
      callbackRef.current(file)
      callbackRef.current = undefined
    }
    e.target.value = '' // allow re-upload of same file
  }

  return (
    <FileUploadContext.Provider value={{ callUploadFile }}>
      {children}
      <input
        type="file"
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={handleChange}
        accept="image/*"
      />
    </FileUploadContext.Provider>
  )
}

export const useFileUpload = (): FileUploadContextType => {
  const context = useContext(FileUploadContext)
  if (!context) {
    throw new Error('useFileUpload must be used within a FileUploadProvider')
  }
  return context
}
